import Vue from 'vue'
import Meta from 'vue-meta'

Vue.use(Meta)



// WEBPACK FOOTER //
// ./src/initializers/vue-meta.js